function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("polygon", {
  id: "svg_1",
  points: "50 72.03 50 72.03 50 72.03 50 72.03"
}), React.createElement("path", {
  id: "svg_2",
  d: "m49.896651,16.346675a15.1,15.1 0 0 0 -2.34,-8.63a17.29,17.29 0 0 0 -7.32,-6.23l0,0a15.25,15.25 0 0 0 -7.85,-0.92c-2.5,0.36 -5.2,2.07 -7.26,3.66l0,0c-2.06,-1.59 -4.75,-3.3 -7.25,-3.66a15.25,15.25 0 0 0 -7.85,0.92l0,0a17.29,17.29 0 0 0 -7.32,6.23a15.1,15.1 0 0 0 -2.34,8.63l0,0c0,13.33 21,25.88 23.3,27.26l1.46,0.83l1.47,-0.86c2.33,-1.38 23.3,-13.93 23.3,-27.26l0,0.03z"
}), React.createElement("polygon", {
  id: "svg_3",
  points: "50 39.01 50 39.01 50 39.01 50 39.01"
}));

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "50mm",
    height: "45mm",
    viewBox: "0 0 50 45",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.bd5de165.svg";
export { ForwardRef as ReactComponent };